import { _, Backbone } from "js/vendor";
import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { FontSets } from "js/core/models/fonts";
import { ShapeType, ShapeColorStyle, IconStyle, ThemeStyleWeight } from "common/constants";
import { enumsToItemArray } from "js/core/utilities/utilities";
import { controls } from "js/editor/ui";

export const ThemeDebugPanel = Backbone.View.extend({
    className: "themeDebugPanel",

    render: function() {
        this.$el.empty();
        let theme = app.currentTheme;

        this.listenTo(ds.selection.presentation, "change:themeId", () => {
            _.defer(() => this.render());
        });

        let userThemes = ds.userThemes.filter(theme => !theme.get("private")).map(theme => {
            return { value: theme.id, label: theme.get("name") };
        });

        let $theme = this.$el.addEl(controls.createDropdownMenu(this, {
            label: "Theme",
            items: userThemes,
            value: theme.id,
            callback: value => {
                ds.selection.presentation.update({ themeId: value });

                app.themeManager.loadTheme(ds.selection.presentation).then(() => {
                    _.each(app.mainView.editorView.slides, function(slide) {
                        if (slide.canvas.layouter) slide.canvas.layouter.reload().catch(err => {
                            console.log("Layout does not fit: " + err);
                        });
                    });
                });
            }
        }));

        if (theme.isBespoke()) {
            this.$el.append(controls.createDropdownMenu(this, {
                label: "Variation",
                items: _.map(theme.get("availableVariations"), variation => {
                    return {
                        value: variation.id,
                        label: variation.name
                    };
                }),
                model: theme,
                property: "variation",
                callback: value => this.reloadTheme()
            }));
        } else {
            let fontSets = _.map(FontSets, fontSet => {
                return { value: fontSet.id, label: fontSet.titleFont + "/" + fontSet.bodyFont };
            });

            this.$el.append(controls.createDropdownMenu(this, {
                label: "FontSet",
                items: fontSets,
                model: theme,
                property: "styleFonts",
                callback: value => {
                    this.reloadTheme();
                }
            }));

            this.$el.append(controls.createDropdownMenu(this, {
                label: "Design",
                items: [
                    { value: 1, label: "Design1" },
                    { value: 2, label: "Design2" },
                    { value: 3, label: "Design3" },
                    { value: 4, label: "Design4" },
                ],
                model: theme,
                property: "styleDesign",
                callback: value => {
                    this.reloadTheme();
                }
            }));

            this.$el.append(controls.createDropdownMenu(this, {
                label: "Shape",
                items: enumsToItemArray(ShapeType),
                model: theme,
                property: "styleShape",
                callback: value => {
                    this.reloadTheme();
                }
            }));

            // this.$el.append(controls.createDropdownMenu(this, {
            //     label: "Default Color",
            //     items: [
            //         {value: "slide", label: "Slide Color"},
            //         {value: "colorful", label: "Colorful"},
            //         {value: "gradient", label: "Gradient"}
            //     ],
            //     model: theme,
            //     property: "styleColor",
            //     callback: (value) => {
            //         this.reloadTheme();
            //     }
            // }));

            this.$el.append(controls.createDropdownMenu(this, {
                label: "Weight",
                items: enumsToItemArray(ThemeStyleWeight),
                model: theme,
                property: "styleWeight",
                callback: value => {
                    this.reloadTheme();
                }
            }));

            this.$el.append(controls.createDropdownMenu(this, {
                label: "Effect",
                items: [
                    { value: "none", label: "None" },
                    { value: "shadow", label: "Shadow" },
                    { value: "sketchy", label: "Sketchy" },
                    { value: "gradient", label: "Gradient" },
                    { value: "block", label: "Block" },
                ],
                model: theme,
                property: "styleEffect",
                callback: value => {
                    this.reloadTheme();
                }
            }));
            //
            // if (theme.get("isBuiltIn")) {
            //     this.$el.find(".control").addClass("disabled");
            //     $theme.removeClass("disabled");
            // }
        }

        return this;
    },

    reloadTheme: function() {
        app.themeManager.loadTheme(ds.selection.presentation).then(() => {
            for (var slide of app.mainView.editorView.slides) {
                if (slide.canvas.layouter) {
                    slide.canvas.layouter.reload();
                }
            }
        });
    }

});
